module.exports = __webpack_public_path__ + "static/media/background.207144f2.png";